import React, { useEffect, useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart, Trophy, Star, Clock, ArrowRight, ShieldCheck, Zap } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'combo' | 'base'>('combo');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 24,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 md:py-16 px-4 bg-slate-950" id="pricing" aria-labelledby="pricing-heading" data-id="element-245">
      <div className="max-w-2xl mx-auto" data-id="element-246">
        {/* Countdown Header */}
        <FadeIn className="text-center mb-8" data-id="element-247">
          <div className="inline-flex items-center justify-center gap-2 bg-red-500/10 text-red-500 border border-red-500/20 px-6 py-3 rounded-full mb-6" data-id="element-248">
            <Clock className="w-5 h-5" data-id="element-249" />
            <span className="font-bold tracking-wide" data-id="element-250">
              PRECIO DE LANZAMIENTO — CIERRA EN:
            </span>
            <span className="font-mono font-black text-lg ml-2" data-id="element-251">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
          <p className="text-amber-500 font-bold mb-8" data-id="element-252">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>

          <h2 id="pricing-heading" className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-253">
            ELEGÍ TU PACK
          </h2>
          <p className="text-slate-400 mb-2" data-id="element-254">
            Cupos al precio de lanzamiento — Quedan pocos
          </p>
          <div className="w-full max-w-xs mx-auto bg-slate-800 rounded-full h-2 mb-2" data-id="element-255">
            <div className="bg-amber-500 h-2 rounded-full" style={{
            width: '68%'
          }} data-id="element-256"></div>
          </div>
          <p className="text-xs text-slate-500" data-id="element-257">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </FadeIn>

        {/* Selection Cards */}
        <FadeIn delay={0.1} data-id="element-258">
          <div id="pricing-cards" className="space-y-4 mb-8 scroll-mt-16" data-id="element-259">
            {/* Combo Pro — Premium recommended card */}
            <div className="relative pt-3" data-id="element-260">
              {/* Floating "Recomendado" ribbon */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 z-10 flex items-center gap-1.5 bg-amber-500 text-slate-950 text-[10px] md:text-xs font-black tracking-widest uppercase px-4 py-1.5 rounded-full shadow-lg shadow-amber-500/40" data-id="element-261">
                <Star size={12} fill="currentColor" aria-hidden="true" data-id="element-262" />
                RECOMENDADO
              </div>

              <button onClick={() => setSelected('combo')} aria-pressed={selected === 'combo'} aria-label="Seleccionar Combo Pro — 6 tomos + 4 bonos + Pelotón 10X por $29.990" className={`relative w-full text-left rounded-2xl p-6 border-2 transition-all duration-300 overflow-hidden ${selected === 'combo' ? 'border-amber-500 bg-gradient-to-br from-slate-900 via-slate-900 to-amber-950/30 shadow-[0_0_40px_rgba(245,158,11,0.15)]' : 'border-slate-800 bg-slate-900/50 opacity-80 hover:opacity-100'}`} data-id="element-263">
                {selected === 'combo' && <div aria-hidden="true" className="absolute -top-20 -right-20 w-40 h-40 bg-amber-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-264" />}

                <div className="relative flex items-start gap-4" data-id="element-265">
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center transition-colors ${selected === 'combo' ? 'border-amber-500 bg-amber-500' : 'border-slate-600'}`} aria-hidden="true" data-id="element-266">
                    {selected === 'combo' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-267" />}
                  </div>

                  <div className="flex-grow" data-id="element-268">
                    <div className="flex items-center justify-between flex-wrap gap-2 mb-3" data-id="element-269">
                      <div className="flex items-center gap-2" data-id="element-270">
                        <Trophy className="w-5 h-5 text-amber-500" data-id="element-271" />
                        <span className="text-xl font-black text-white tracking-wide" data-id="element-272">
                          COMBO PRO
                        </span>
                      </div>
                      <div className="text-right" data-id="element-273">
                        <span className="text-slate-500 line-through text-sm mr-2" data-id="element-274">
                          $69.990
                        </span>
                        <span className="text-2xl font-black text-amber-400" data-id="element-275">
                          $29.990
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2 mb-4" data-id="element-276">
                      <span className="inline-flex items-center gap-1 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-277">
                        <Star size={12} fill="white" data-id="element-278" /> MÁS ELEGIDO
                      </span>
                      <span className="inline-flex items-center border border-amber-500/60 text-amber-400 text-xs font-bold px-3 py-1 rounded-full" data-id="element-279">
                        🔥 Subí de categoría
                      </span>
                    </div>

                    <p className="text-white font-bold mb-1" data-id="element-280">
                      PROTORRENDA 4-12 + PELOTÓN 10X
                    </p>

                    <p className="text-slate-400 text-xs italic" data-id="element-281">
                      Para el que también quiere dominar el pelotón.
                    </p>

                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-4 pt-4 border-t border-slate-800/80 text-xs text-slate-300" data-id="element-282">
                      <span className="flex items-center gap-1" data-id="element-283">
                        <span className="text-amber-500" data-id="element-284">✓</span> 6 Tomos
                      </span>
                      <span className="flex items-center gap-1" data-id="element-285">
                        <span className="text-amber-500" data-id="element-286">✓</span> 4 Bonos
                      </span>
                      <span className="flex items-center gap-1" data-id="element-287">
                        <span className="text-amber-500" data-id="element-288">✓</span> Pelotón 10X
                      </span>
                      <span className="flex items-center gap-1" data-id="element-289">
                        <span className="text-amber-500" data-id="element-290">✓</span> Tácticas
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            </div>

            {/* Pack Base */}
            <button onClick={() => setSelected('base')} aria-pressed={selected === 'base'} aria-label="Seleccionar Pack Base — 6 tomos + 4 bonos por $19.990" className={`w-full text-left rounded-2xl p-6 border-2 transition-all duration-300 ${selected === 'base' ? 'border-green-500 bg-slate-900 shadow-[0_0_20px_rgba(34,197,94,0.1)]' : 'border-slate-800 bg-slate-900/50 opacity-70'}`} data-id="element-291">
              <div className="flex items-center gap-4" data-id="element-292">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'base' ? 'border-green-500 bg-green-500' : 'border-slate-600'}`} aria-hidden="true" data-id="element-293">
                  {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-294" />}
                </div>

                <div className="flex-grow" data-id="element-295">
                  <div className="flex items-center justify-between flex-wrap gap-2 mb-2" data-id="element-296">
                    <div data-id="element-297">
                      <div className="flex items-center gap-2 mb-1" data-id="element-298">
                        <span className="text-blue-400" data-id="element-299">📘</span>
                        <span className="text-xl font-bold text-white" data-id="element-300">
                          PACK BASE
                        </span>
                      </div>
                    </div>
                    <div className="text-right" data-id="element-301">
                      <span className="text-slate-500 line-through text-sm mr-2" data-id="element-302">
                        $49.990
                      </span>
                      <span className="text-2xl font-bold text-green-500" data-id="element-303">
                        $19.990
                      </span>
                    </div>
                  </div>
                  <p className="text-slate-300 font-medium mb-1" data-id="element-304">
                    PROTORRENDA 4-12
                  </p>
                  <p className="text-slate-400 text-sm mb-3" data-id="element-305">
                    6 Tomos + 4 Bonos
                  </p>
                  <p className="text-slate-500 text-xs italic" data-id="element-306">
                    Sistema completo de entrenamiento, nutrición y ajuste.
                  </p>
                </div>
              </div>
            </button>
          </div>
        </FadeIn>

        {/* Main CTA Button */}
        <FadeIn delay={0.2} data-id="element-307">
          <a id="pricing-cta" href={selected === 'combo' ? 'https://fegion.shop/cart/46201151553675:1' : 'https://fegion.shop/cart/46201145950347:1'} target="_blank" rel="noopener noreferrer" className="group relative w-full flex flex-col items-center justify-center py-5 px-6 rounded-2xl bg-gradient-to-b from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-black transition-all shadow-[0_10px_30px_rgba(34,197,94,0.35)] hover:shadow-[0_15px_40px_rgba(34,197,94,0.5)] hover:scale-[1.02] active:scale-[0.99] overflow-hidden" aria-label={`Comprar ${selected === 'combo' ? 'Combo Pro por $29.990' : 'Pack Base por $19.990'}`} data-id="element-308">
            {/* Shimmer effect */}
            <span aria-hidden="true" className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-309" />

            <span className="relative flex items-center justify-center gap-3 text-xl md:text-2xl" data-id="element-310">
              <span aria-hidden="true" className="text-2xl" data-id="element-311">
                ✨
              </span>
              EMPEZAR AHORA — ${selected === 'combo' ? '29.990' : '19.990'}
              <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-312" />
            </span>
            <span className="relative text-xs font-medium text-green-50/90 mt-1.5 tracking-wide" data-id="element-313">
              Acceso inmediato · Garantía 7 días
            </span>
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs text-slate-500 mt-3" data-id="element-314">
            <span className="flex items-center gap-1" data-id="element-315">
              <ShieldCheck size={14} className="text-green-500" aria-hidden="true" data-id="element-316" />
              Pago seguro
            </span>
            <span className="text-slate-700" data-id="element-317">·</span>
            <span className="flex items-center gap-1" data-id="element-318">
              <Zap size={14} className="text-amber-500" aria-hidden="true" data-id="element-319" />
              Recibís todo en 5 minutos
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}